const HttpResponseCodes = {
    UNAUTHORIZED: 401,
    FORBIDDEN: 403
};

export const httpConstants = {
    HttpResponseCodes
};
